import {AbstractService} from "@/services/AbstractService";

export abstract class AbstractStorageModule extends AbstractService{
    modules: null|string[] = null;

    async init() {
        if(!this.modules) return;

        for (const module of this.modules) {
            await this[module].init();
        }
    }
}